import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "bg-background min-h-screen" }
const _hoisted_3 = { class: "container flex-grow my-8" }
const _hoisted_4 = { class: "flex flex-row items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Back")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex flex-col card-main mt-8" }
const _hoisted_8 = {
  key: 0,
  class: "text-lg font-semibold"
}
const _hoisted_9 = {
  key: 1,
  class: "text-lg font-semibold"
}
const _hoisted_10 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Company", -1)
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Job (Optional if you want to pre-load values)", -1)
const _hoisted_15 = {
  key: 0,
  class: "my-4"
}
const _hoisted_16 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Name", -1)
const _hoisted_19 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Department", -1)
const _hoisted_22 = { class: "flex flex-col mt-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Responsibilities", -1)
const _hoisted_24 = { class: "flex flex-col mt-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Requirements", -1)
const _hoisted_26 = { class: "flex flex-col mt-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Benefits", -1)
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "usd" }, "US Dollar (USD)", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "mxn" }, "Mexican Peso (MXN)", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "flex flex-row items-center mt-4" }
const _hoisted_34 = { class: "mr-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "usd" }, "US Dollar (USD)", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "mxn" }, "Mexican Peso (MXN)", -1)
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = {
  key: 2,
  class: "bg-gray-300 h-px w-full my-8"
}
const _hoisted_39 = {
  key: 3,
  class: "flex flex-col"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Talent assigned to this role", -1)
const _hoisted_41 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 h-px w-full my-8" }, null, -1)
const _hoisted_43 = { class: "flex flex-row justify-end" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_SelectDropdown = _resolveComponent("SelectDropdown")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Bullets = _resolveComponent("Bullets")!
  const _component_NewCurrencyField = _resolveComponent("NewCurrencyField")!
  const _component_UserCard = _resolveComponent("UserCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn-outline-lg",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnToCompany && _ctx.returnToCompany(...args)))
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (!_ctx.editable)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Add new role"))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, "Edit role")),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_SelectDropdown, {
                modelValue: _ctx.company_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company_id) = $event)),
                options: _ctx.companies,
                label: "Company...",
                name: "company_id"
              }, null, 8, ["modelValue", "options"])
            ]),
            (!_ctx.editable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  (_ctx.jobsLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_Spinner, { color: "primary" })
                      ]))
                    : (_openBlock(), _createBlock(_component_SelectDropdown, {
                        key: 1,
                        modelValue: _ctx.job_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.job_id) = $event)),
                        options: _ctx.jobs,
                        label: "Jobs",
                        name: "job_id"
                      }, null, 8, ["modelValue", "options"]))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_TextField, {
                modelValue: _ctx.name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.name) = $event)),
                name: "name",
                label: "Name..."
              }, null, 8, ["modelValue"]),
              (_ctx.errorName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, " This role already exists. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_SelectDropdown, {
                modelValue: _ctx.department,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.department) = $event)),
                options: _ctx.departmentOptions,
                name: "department",
                label: "Department..."
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_Bullets, {
              modelValue: _ctx.responsibilities,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.responsibilities) = $event)),
              name: "responsibilities",
              placeholder: "Responsibilities..."
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_Bullets, {
              modelValue: _ctx.requirements,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requirements) = $event)),
              name: "requirements",
              placeholder: "Requirements..."
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefits, (benefit, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: _normalizeClass(["flex flex-row", { 'mt-4': i > 0 }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((_ctx.benefits[i].name) = $event),
                  placeholder: "Name",
                  type: "text",
                  class: "bg-background rounded px-4 py-5 focus:outline-none disabled:cursor-not-allowed mr-4"
                }, null, 8, _hoisted_28), [
                  [_vModelText, _ctx.benefits[i].name]
                ]),
                (_openBlock(), _createBlock(_component_NewCurrencyField, {
                  modelValue: _ctx.benefits[i].value,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.benefits[i].value) = $event),
                  name: `benefits-${i}-value`,
                  label: "Amount",
                  key: _ctx.refreshCounterChange
                }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((_ctx.benefits[i].currency) = $event),
                  class: "bg-background py-5 px-3 rounded ml-4 disabled:cursor-not-allowed"
                }, _hoisted_32, 8, _hoisted_29), [
                  [_vModelSelect, _ctx.benefits[i].currency]
                ])
              ], 2))
            }), 128)),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newBenefitName) = $event)),
                  placeholder: "New item",
                  type: "text",
                  class: "bg-background rounded px-4 py-5 focus:outline-none"
                }, null, 512), [
                  [_vModelText, _ctx.newBenefitName]
                ])
              ]),
              (_openBlock(), _createBlock(_component_NewCurrencyField, {
                modelValue: _ctx.newBenefitAmount,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newBenefitAmount) = $event)),
                name: "newBenefitAmount",
                label: "Amount",
                key: _ctx.refreshCounterV
              }, null, 8, ["modelValue"])),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newBenefitCurrency) = $event)),
                class: "bg-background py-5 px-3 rounded ml-4"
              }, _hoisted_37, 512), [
                [_vModelSelect, _ctx.newBenefitCurrency]
              ]),
              _createElementVNode("button", {
                class: "btn-filled-sm ml-4",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.addBenefit && _ctx.addBenefit(...args)))
              }, " Add benefit ")
            ])
          ]),
          (_ctx.users.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38))
            : _createCommentVNode("", true),
          (_ctx.users.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                      _createVNode(_component_UserCard, {
                        id: user.id,
                        firstName: user.first_name,
                        lastName: user.last_name,
                        position: user.job_title
                      }, null, 8, ["id", "firstName", "lastName", "position"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
              class: _normalizeClass({
                'btn-filled-lg': !_ctx.loading,
                'btn-filled-lg-loading': _ctx.loading,
              })
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Loading..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_45, "Done"))
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}